import { type SvgComponentType } from "@newsela/angelou";

import { useGetReportsMenuSectionProps } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useGetReportsMenuSectionProps/useGetReportsMenuSectionProps";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem/PopoutSectionItem";
import { HomeMenuSubItemPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubItemPopout/HomeMenuSubItemPopout";

const HomeMenuReportsPopout = ({ onClickBack }: IHomeMenuClassesPopout) => {
  const { reportsMenuSectionTitle, reportsMenuSectionItems } =
    useGetReportsMenuSectionProps();

  return (
    <HomeMenuSubItemPopout
      dataTestId="home-classes-popout"
      onClickBack={onClickBack}
    >
      <PopoutMenuSection width="15.625rem" title={reportsMenuSectionTitle}>
        {reportsMenuSectionItems.map(
          ({ title, href, SvgComponent, dataQASelector }, index) => (
            <PopoutSectionItem
              key={index}
              href={href}
              title={title}
              SvgComponent={SvgComponent as SvgComponentType}
              dataQASelector={dataQASelector}
            />
          ),
        )}
      </PopoutMenuSection>
    </HomeMenuSubItemPopout>
  );
};

interface IHomeMenuClassesPopout {
  onClickBack: () => void;
}

HomeMenuReportsPopout.displayName = "HomeMenuReportsPopout";
export { HomeMenuReportsPopout };
